import { createColor } from '@manakin/theme/lib/color';

const green = createColor('#C0E1D7');

export default green;
